
import { mapActions, mapState, mapGetters } from "vuex";
import currencyConverter from "../common/currency-converter.vue";
import AddToCart from "../cart/add-to-cart.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
import MenuOrderItemTextDraft from "../menu-order/menu-order-item-text-draft.vue";
export default {
  name: "AddedItemCustomisationDialog",
  components: {
    ResponsiveDialog,
    currencyConverter,
    AddToCart,
    MenuOrderItemTextDraft
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters("order", ["getCartItemList"]),
    cartItemList() {
      return this.getCartItemList({ menuId: this.item.id });
    },
    exactCartItem() {
      return (
        this.cartItemList.find((cartItem) => cartItem.id === this.item.id) ||
        null
      );
    }
  },
  data() {
    return {
      valid: false,
      selectedVariant: "",
      selectedChoice: "",
      selectedAddons: [],
      isChoicesMandatory: true,
      variantQuantity: 1,
      loading: false
    };
  },
  methods: {
    handleAddAnotherCustomisation() {
      this.$nuxt.$emit("open-add-to-cart-dialog", this.item);
      this.$emit("close-dialog");
    },
    handleEdit(item) {
      this.$nuxt.$emit("open-add-to-cart-dialog", item);
      this.$emit("close-dialog");
    }
  }
};
